import { render, staticRenderFns } from "./CDOrganizationSocialLinks.vue?vue&type=template&id=284dc2eb&scoped=true"
import script from "./CDOrganizationSocialLinks.vue?vue&type=script&lang=ts"
export * from "./CDOrganizationSocialLinks.vue?vue&type=script&lang=ts"
import style0 from "./CDOrganizationSocialLinks.vue?vue&type=style&index=0&id=284dc2eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284dc2eb",
  null
  
)

export default component.exports